import {Injectable} from '@angular/core';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireSquadStaffMember} from '@tisa-group/models';

@Injectable()
export class SquadStaffMemberService implements CrudService<UmpireSquadStaffMember> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireSquadStaffMember[]>> {
    return this.http
      .get(`/squad_staff_members`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireSquadStaffMember>> {
    return this.http
      .get(`/squad_staff_members/${fetchIdentifier}`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  create(
    body: Partial<UmpireSquadStaffMember>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireSquadStaffMember>> {
    return this.http
      .post<JsonApiResponse<UmpireSquadStaffMember>>(
        '/squad_staff_members',
        serialize({stuff: body, includeNames: ['staff_member', 'squad']}),
        {params: objectToHttpParams(params)},
      )
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireSquadStaffMember>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireSquadStaffMember>> {
    return this.http
      .patch<JsonApiResponse<UmpireSquadStaffMember>>(
        `/squad_staff_members/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/squad_staff_members/${id}`);
  }
}
